// eslint-disable-next-line import/prefer-default-export
export const isSnakeCase = (value: string) => /^([a-z0-9]{1,})(_[a-z0-9]{1,})*$/.test(value);
